import type {PriceFilterConfig} from '@/config/models';

import {uniq} from 'lodash';

export const createSliderValues = (ranges: PriceFilterConfig['ranges']) => {
  return uniq(
    ranges.reduce<Array<number>>((accumulator, current) => {
      for (
        let price = current.minValue;
        price <= current.maxValue;
        price += current.step
      ) {
        accumulator.push(price);
      }

      return accumulator;
    }, [])
  );
};
